import { Application } from '@plasma/ui.application.app-provider';
import { smsLogo } from './services/Auth/Logos';

export const applications = (title: string, logo: string): Application[] => {
  return [
    {
      icon: smsLogo,
      iconDark:
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDExSDFWMzFIMjFWMjFIMTFWMTFaIiBmaWxsPSIjMDc3NUJDIi8+CjxwYXRoIGQ9Ik0xNiAxMVYxSDMxVjE2SDIxVjExSDE2WiIgZmlsbD0iI0UxMDgxNCIvPgo8cmVjdCB4PSIxMyIgeT0iMTMiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIGZpbGw9IiMxQTFBMTgiLz4KPC9zdmc+Cg==',
      favorite: false,
      id: '${REPO_NAME}',
      name: 'SMS Group',
      aboutUrl: '',
      url: 'http://localhost:8081',
      version: `${require('../package.json')?.version ?? '0.0.0'}`,
    },
  ];
};
